import { Typography } from "@mui/material";
import {
  Close,
  InactiveModal,
  ModalContainer,
  NoteContainer,
  Notes,
} from "../../styles";

interface CallPushedModalProps {
  onClose: () => void;
}

export const CallPushedModal = (props: CallPushedModalProps) => (
  <ModalContainer>
    <InactiveModal>
      <NoteContainer>
        <Notes>Note</Notes>
        <Close
          onClick={() => {
            props.onClose();
          }}
        >
          X
        </Close>
      </NoteContainer>
      <Typography maxWidth={350} textAlign="center">
        <strong>A call has been made to the user!</strong>
      </Typography>
    </InactiveModal>
  </ModalContainer>
);
